import React from 'react';
import {
  Show,
  TabbedShowLayout,
  TextField,
  ReferenceManyField,
  Datagrid,
  ReferenceField, Tab,
} from 'react-admin';

const GrupoReglaShow = (props) => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="resources.grupo-regla.tabs.general">
        <TextField source="descripcion" />
        {/* Prestaciones */}
      </Tab>
      <Tab label="resources.grupo-regla.tabs.prestaciones">
        <ReferenceManyField
          addLabel={false}
          reference="prestacion-grupo-regla"
          source="id"
          target="idGrupoRegla"
          sort={{ field: "idPrestacion", order: "DESC" }}
        >
          <Datagrid rowClick="show">
            <TextField source="idPrestacion" label="resources.grupo-regla.fields.id"/>
            <ReferenceField
              label="resources.grupo-regla.fields.descripcion"
              source="idPrestacion"
              reference="prestaciones"
              link={false}
              filter={{ deleted: false }}
            >
              <TextField source="descripcion" />
            </ReferenceField>
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export default GrupoReglaShow;
